/**
 * WorkShell — shell at /apps/:appId/work
 * Renders Tasks only. Feed and Performance are top-level sidebar routes.
 */
import React from 'react';
import { Outlet } from 'react-router-dom';

export default function WorkShell() {
  return <Outlet />;
}
